var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.zoom.showImg != null)?_c('div',{staticClass:"crpg-o-common-zoom-image",on:{"click":_vm.close}},[_c('MoleculesCommonZoomImage')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }